<template>
  <div class="video-card" @click="goToWatch">

    <!-- THUMBNAIL -->
    <div class="thumbnail-wrapper">
      <img
        :src="thumbnailUrl"
        alt="Thumbnail"
        class="thumbnail"
      />

      <!-- PLAY ICON -->
      <div class="play-overlay">
        <i class="mdi mdi-play-circle-outline"></i>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="video-body">
      <h6 class="video-title" :title="video.title"> 
        {{ video.title }}
      </h6>

      <div class="video-meta">
        <span class="badge badge-soft-primary">
          {{ video.category?.name || "-" }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "VideoCard",

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  computed: {
    thumbnailUrl() {
      /**
       * Fallback AMAN:
       * - hqdefault → kualitas bagus
       * - mqdefault → fallback kalau hq gagal
       */
      if (!this.video.youtube_video_id) {
        return "https://img.youtube.com/vi/dQw4w9WgXcQ/mqdefault.jpg";
      }

      return `https://img.youtube.com/vi/${this.video.youtube_video_id}/hqdefault.jpg`;
    },
  },

  methods: {
    goToWatch() {
      this.$router.push({
        name: "kms-user-video-watch",
        params: { id: this.video.id },
      });
    },
  },
};
</script>

<style scoped>
.video-card {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.25s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.thumbnail-wrapper {
  position: relative;
  overflow: hidden;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.thumbnail {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
}

.play-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.video-card:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 48px;
  color: #fff;
}

.video-body {
  padding: 12px;
  flex: 1;
}

.video-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 6px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-meta {
  margin-top: 4px;
}

.badge-soft-primary {
  background-color: rgba(85, 110, 230, 0.15);
  color: #556ee6;
}
</style>
